import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl-redux';
import React from 'react';
import { render } from 'react-dom';
import { withRouter } from 'react-router-dom';

import store, { history } from './configuration/store';
import initializeLocalization from './configuration/localization';
import { initializeIdentity } from './utilities/user';
import { initializeMixpanel } from './utilities/mixpanel';
import { initializeHotjar } from './utilities/hotjar';
import ErrorHandler from './components/errorHandler';
import Router from './router';

import 'rc-tooltip/assets/bootstrap.css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/root.css';
import './styles/inputs.css';

initializeMixpanel();
initializeHotjar();
initializeLocalization();
initializeIdentity();

const root = document.getElementById('root');
const Application = withRouter(Router);
const app = (
    <ErrorHandler>
        <Provider store={store}>
            <IntlProvider textComponent={React.Fragment}>
                <ConnectedRouter history={history}>
                    <Application />
                </ConnectedRouter>
            </IntlProvider>
        </Provider>
    </ErrorHandler>
);

render(app, root);



// WEBPACK FOOTER //
// ./src/index.js